// import React, { useState } from "react";
// import Navbar from "./Navbar";
// import Footer from "./Footer";
// import { URL } from "../urls";

// /* ---------------- Contact Page ---------------- */

// const Contact = () => {
//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     subject: "",
//     message: "",
//     category: "general",
//   });
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [submitStatus, setSubmitStatus] = useState({ type: "", message: "" });

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setIsSubmitting(true);
//     setSubmitStatus({ type: "", message: "" });

//     try {
//       const response = await fetch(URL.CONTACT_SUBMIT, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(formData),
//       });

//       const result = await response.json().catch(() => ({}));

//       if (!response.ok) {
//         throw new Error(result.error || "Failed to submit your message");
//       }

//       setSubmitStatus({
//         type: "success",
//         message: "Thank you! Your message has been sent successfully.",
//       });
//       setFormData({
//         name: "",
//         email: "",
//         subject: "",
//         message: "",
//         category: "general",
//       });
//     } catch (error) {
//       setSubmitStatus({
//         type: "error",
//         message: error.message || "Something went wrong. Please try again.",
//       });
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   const handleChange = (e) => {
//     setFormData({
//       ...formData,
//       [e.target.name]: e.target.value,
//     });
//   };

//   return (
//     <div style={{ width: "100vw", minHeight: "100vh" }}>
//       <div
//         style={{
//           minHeight: "100vh",
//           width: "100%",
//           fontFamily: "Arial, sans-serif",
//           color: "#fff",
//         }}
//       >
//         <Navbar />

//         <section style={{ textAlign: "center", padding: "4rem 1rem" }}>
//           <h1
//             style={{
//               fontSize: "3rem",
//               fontWeight: "bold",
//               marginBottom: "1rem",
//             }}
//           >
//             Get in <span style={{ color: "#8b5cf6" }}>Touch</span>
//           </h1>
//           <p
//             style={{
//               fontSize: "1.2rem",
//               maxWidth: "700px",
//               margin: "0 auto",
//             }}
//           >
//             Have questions about our AI agents or need help getting started? Our
//             team is here to help you succeed with your automation journey.
//           </p>
//         </section>

//         <section
//           style={{ padding: "2rem 1rem", maxWidth: "800px", margin: "0 auto" }}
//         >
//           <h2
//             style={{
//               fontSize: "2rem",
//               marginBottom: "1.5rem",
//               textAlign: "center",
//             }}
//           >
//             Send Us a Message
//           </h2>
//           <form onSubmit={handleSubmit}>
//             {submitStatus.message && (
//               <div
//                 style={{
//                   marginBottom: "1rem",
//                   padding: "0.75rem 1rem",
//                   borderRadius: "8px",
//                   background:
//                     submitStatus.type === "success"
//                       ? "rgba(16, 185, 129, 0.2)"
//                       : "rgba(239, 68, 68, 0.2)",
//                   border:
//                     submitStatus.type === "success"
//                       ? "1px solid rgba(16, 185, 129, 0.5)"
//                       : "1px solid rgba(239, 68, 68, 0.5)",
//                   color: "#fff",
//                 }}
//               >
//                 {submitStatus.message}
//               </div>
//             )}
//             <div style={{ marginBottom: "1.2rem" }}>
//               <label>Full Name *</label>
//               <input
//                 type="text"
//                 name="name"
//                 required
//                 value={formData.name}
//                 onChange={handleChange}
//                 style={{
//                   width: "100%",
//                   padding: "0.8rem",
//                   borderRadius: "8px",
//                   border: "1px solid rgba(255,255,255,0.3)",
//                   background: "rgba(255,255,255,0.1)",
//                   color: "white",
//                 }}
//               />
//             </div>
//             <div style={{ marginBottom: "1.2rem" }}>
//               <label>Email Address *</label>
//               <input
//                 type="email"
//                 name="email"
//                 required
//                 value={formData.email}
//                 onChange={handleChange}
//                 style={{
//                   width: "100%",
//                   padding: "0.8rem",
//                   borderRadius: "8px",
//                   border: "1px solid rgba(255,255,255,0.3)",
//                   background: "rgba(255,255,255,0.1)",
//                   color: "white",
//                 }}
//               />
//             </div>
//             <div style={{ marginBottom: "1.2rem" }}>
//               <label>Category</label>
//               <select
//                 name="category"
//                 value={formData.category}
//                 onChange={handleChange}
//                 style={{
//                   width: "100%",
//                   padding: "0.8rem",
//                   borderRadius: "8px",
//                   border: "1px solid rgba(255,255,255,0.3)",
//                   background: "rgba(255,255,255,0.1)",
//                   color: "white",
//                 }}
//               >
//                 <option value="general">General Inquiry</option>
//                 <option value="support">Technical Support</option>
//                 <option value="sales">Sales Question</option>
//                 <option value="partnership">Partnership</option>
//                 <option value="feedback">Feedback</option>
//               </select>
//             </div>
//             <div style={{ marginBottom: "1.2rem" }}>
//               <label>Subject *</label>
//               <input
//                 type="text"
//                 name="subject"
//                 required
//                 value={formData.subject}
//                 onChange={handleChange}
//                 style={{
//                   width: "100%",
//                   padding: "0.8rem",
//                   borderRadius: "8px",
//                   border: "1px solid rgba(255,255,255,0.3)",
//                   background: "rgba(255,255,255,0.1)",
//                   color: "white",
//                 }}
//               />
//             </div>
//             <div style={{ marginBottom: "1.2rem" }}>
//               <label>Message *</label>
//               <textarea
//                 name="message"
//                 required
//                 rows={6}
//                 value={formData.message}
//                 onChange={handleChange}
//                 style={{
//                   width: "100%",
//                   padding: "0.8rem",
//                   borderRadius: "8px",
//                   border: "1px solid rgba(255,255,255,0.3)",
//                   background: "rgba(255,255,255,0.1)",
//                   color: "white",
//                 }}
//               />
//             </div>
//             <div style={{ textAlign: "center" }}>
//               <button
//                 type="submit"
//                 disabled={isSubmitting}
//                 style={{
//                   background: "#9333ea",
//                   padding: "0.8rem 2rem",
//                   borderRadius: "8px",
//                   color: "white",
//                   fontWeight: "bold",
//                   border: "none",
//                   cursor: isSubmitting ? "not-allowed" : "pointer",
//                   opacity: isSubmitting ? 0.7 : 1,
//                 }}
//               >
//                 {isSubmitting ? "Sending..." : "Send Message"}
//               </button>
//             </div>
//           </form>
//         </section>

//         <Footer />
//       </div>
//     </div>
//   );
// };

// export default Contact;


import React, { useState } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { URL } from "../urls";
import "./Contact.css";

/* ---------------- Contact Page ---------------- */

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
    category: "general",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState({ type: "", message: "" });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus({ type: "", message: "" });

    try {
      const response = await fetch(URL.CONTACT_SUBMIT, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const result = await response.json().catch(() => ({}));

      if (!response.ok) {
        throw new Error(result.error || "Failed to submit your message");
      }

      setSubmitStatus({
        type: "success",
        message: "✓ Thank you! Your message has been sent successfully.",
      });
      setFormData({ name: "", email: "", subject: "", message: "", category: "general" });
    } catch (error) {
      setSubmitStatus({
        type: "error",
        message: "✕ " + (error.message || "Something went wrong. Please try again."),
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <div className="contact-page">
      <Navbar />

      <main className="contact-main">
        <div className="contact-wrapper">

          {/* ── Left Panel ── */}
          <div className="contact-left">

            {/* Heading block */}
            <div className="contact-heading-block">
              <div className="contact-eyebrow">
                <span className="contact-eyebrow-dot" />
                We're here to help
              </div>
              <h1>
                Get in <span>Touch</span>
              </h1>
              <p>
                Have questions about our AI agents or need help getting started?
                Our team is ready to assist you on your automation journey.
              </p>
            </div>

            {/* Info cards */}
            <div className="contact-info-cards">
              <div className="contact-info-card">
                <div className="contact-info-icon">📧</div>
                <div className="contact-info-text">
                  <strong>Email Us</strong>
                  <span>support@aisleagent.com</span>
                </div>
              </div>
              <div className="contact-info-card">
                <div className="contact-info-icon">⚡</div>
                <div className="contact-info-text">
                  <strong>Response Time</strong>
                  <span>Within 24 hours</span>
                </div>
              </div>
              <div className="contact-info-card">
                <div className="contact-info-icon">🌐</div>
                <div className="contact-info-text">
                  <strong>Support Hours</strong>
                  <span>Mon – Fri, 9 AM – 6 PM</span>
                </div>
              </div>
            </div>
          </div>

          {/* ── Right: Form Card ── */}
          <div className="contact-card">
            <h2 className="contact-card-title">Send Us a Message</h2>
            <p className="contact-card-subtitle">
              Fill in the details below and we'll get back to you shortly.
            </p>

            <form className="contact-form" onSubmit={handleSubmit}>

              {/* Status */}
              {submitStatus.message && (
                <div className={`contact-status ${submitStatus.type}`}>
                  {submitStatus.message}
                </div>
              )}

              {/* Name + Email */}
              <div className="contact-form-row">
                <div className="contact-field">
                  <label htmlFor="name">Full Name *</label>
                  <input
                    id="name"
                    type="text"
                    name="name"
                    required
                    placeholder="Jane Smith"
                    value={formData.name}
                    onChange={handleChange}
                  />
                </div>
                <div className="contact-field">
                  <label htmlFor="email">Email Address *</label>
                  <input
                    id="email"
                    type="email"
                    name="email"
                    required
                    placeholder="jane@example.com"
                    value={formData.email}
                    onChange={handleChange}
                  />
                </div>
              </div>

              {/* Category + Subject */}
              <div className="contact-form-row">
                <div className="contact-field">
                  <label htmlFor="category">Category</label>
                  <select
                    id="category"
                    name="category"
                    value={formData.category}
                    onChange={handleChange}
                  >
                    <option value="general">General Inquiry</option>
                    <option value="support">Technical Support</option>
                    <option value="sales">Sales Question</option>
                    <option value="partnership">Partnership</option>
                    <option value="feedback">Feedback</option>
                  </select>
                </div>
                <div className="contact-field">
                  <label htmlFor="subject">Subject *</label>
                  <input
                    id="subject"
                    type="text"
                    name="subject"
                    required
                    placeholder="How can we help?"
                    value={formData.subject}
                    onChange={handleChange}
                  />
                </div>
              </div>

              {/* Message */}
              <div className="contact-field">
                <label htmlFor="message">Message *</label>
                <textarea
                  id="message"
                  name="message"
                  required
                  rows={5}
                  placeholder="Tell us more about your question or issue..."
                  value={formData.message}
                  onChange={handleChange}
                />
              </div>

              {/* Submit */}
              <button
                type="submit"
                className="contact-submit-btn"
                disabled={isSubmitting}
              >
                {isSubmitting ? (
                  <>
                    <span style={{ opacity: 0.8 }}>Sending</span>
                    <span style={{ animation: "blink 1s infinite" }}>...</span>
                  </>
                ) : (
                  <>Send Message →</>
                )}
              </button>

            </form>
          </div>

        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Contact;
